export default __webpack_public_path__ + "static/media/figma.f5379599.png";